import React, { useEffect, useState } from "react";
import { Alert, Button, Input, List, message, Modal } from "antd";
import { useAtom } from "jotai";
import { SolicitudAusenciaService } from "services";
import { ApiResponse } from "enum";
import produce from "immer";
import {
	solicitudesAusenciaSeleccionadasAtom,
	solicitudesAusenciaPendientesAprobarAtom,
	visibleModalAprobarMasivaSolicitudAusenciaAtom,
} from "../../SolicitudesPendientesAprobarStore";

const ModalAprobarMasivaSolicitudAusencia = () => {
	const [solicitudesSeleccionadas, setSolicitudesSeleccionadas] = useAtom(solicitudesAusenciaSeleccionadasAtom);
	const [, setSolicitudesPendientesAprobar] = useAtom(solicitudesAusenciaPendientesAprobarAtom);
	const [visibleModal, setVisibleModal] = useAtom(visibleModalAprobarMasivaSolicitudAusenciaAtom);
	const [loading, setLoading] = useState(false);
	const [claveIngresada, setClaveIngresada] = useState("");
	const [mensajeError, setMensajeError] = useState("");

	useEffect(() => {
		if (visibleModal) {
			setClaveIngresada("");
			setMensajeError("");
		}
	}, [visibleModal]);

	const onClickBtnAprobar = async () => {
		if (!claveIngresada) {
			setMensajeError("Ingresa tu clave para aprobar.");
			return;
		}
		setLoading(true);
		try {
			const response = await SolicitudAusenciaService.aprobarMasivamentePorJefeInmediato({
				solicitudAusenciaIds: solicitudesSeleccionadas.map((s) => s.id),
				clave: claveIngresada,
			});

			if (response.estado === ApiResponse.EXITO) {
				const idsAprobados = solicitudesSeleccionadas.map((s) => s.id);
				setSolicitudesPendientesAprobar(
					produce((draft) => {
						idsAprobados.forEach((id) => {
							const index = draft.findIndex((s) => s.id === id);
							if (index !== -1) draft.splice(index, 1);
						});
					})
				);
				message.success(`Se aprobaron ${idsAprobados.length} solicitud(es) correctamente.`);
				setSolicitudesSeleccionadas([]);
				setVisibleModal(false);
			} else {
				setMensajeError(response.mensaje || "Ocurrió un error al aprobar las solicitudes.");
			}
		} catch (error) {
			setMensajeError("Ocurrió un error inesperado. Intente nuevamente.");
		} finally {
			setLoading(false);
		}
	};

	const onClickBtnCancelar = () => {
		setVisibleModal(false);
	};

	return (
		<Modal
			title="Aprobar solicitudes seleccionadas"
			visible={visibleModal}
			closable={false}
			width={480}
			destroyOnClose={true}
			footer={[
				<Button key="cancelar" disabled={loading} onClick={onClickBtnCancelar} style={{ padding: "0px 30px" }}>
					Cancelar
				</Button>,
				<Button
					key="aprobar"
					type="primary"
					loading={loading}
					onClick={onClickBtnAprobar}
					style={{ padding: "0px 30px" }}
				>
					Aprobar ({solicitudesSeleccionadas.length})
				</Button>,
			]}
			centered
		>
			{mensajeError && (
				<Alert
					message={mensajeError}
					onClose={() => setMensajeError("")}
					style={{ marginBottom: "8px" }}
					type="error"
					showIcon
					closable
				/>
			)}
			<List
				size="small"
				bordered
				style={{ marginBottom: "12px", maxHeight: 200, overflowY: "auto" }}
				dataSource={solicitudesSeleccionadas}
				renderItem={(item) => (
					<List.Item>
						{item.colaborador?.nombreCompleto} — {item.tipo?.descripcion}
					</List.Item>
				)}
			/>
			<span style={{ display: "block", marginBottom: "4px" }}>Ingresa tu clave para aprobar todas</span>
			<Input.Password
				value={claveIngresada}
				onChange={(e) => {
					setClaveIngresada(e.target.value);
					setMensajeError("");
				}}
				placeholder="Clave"
			/>
		</Modal>
	);
};

export default ModalAprobarMasivaSolicitudAusencia;
